import { useEffect } from 'react';

var useLockBody = function useLockBody(lock) {
  useEffect(function () {
    document.body.style.overflow = lock ? 'hidden' : '';
    return function () {
      document.body.style.overflow = '';
    };
  }, [lock]);
};

export default useLockBody;